import _ from 'lodash';
import { type BoardSource, type PortalSettings } from '@gorilla/portal-shared/src/schemas';
import { Flex, Box, Text, Icon, Heading } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Inbox, Broadcast } from '@vibe/icons';
import { BoardSourceList } from './BoardSourceList';
import { ExternalLink } from './ExternalLink';

type BoardSourcePickerModalProps = {
  portalSettings: PortalSettings;
  onClose: (boardSource?: BoardSource) => void;
};

export function BoardSourcePickerModal({ portalSettings, onClose }: BoardSourcePickerModalProps) {
  return (
    <AppModal
      show={true}
      onClose={() => {
        onClose();
      }}
      contentSpacing={false}
      alertDialog={true}
      width={550}
      id="board-source-picker__modal"
    >
      <AppModalContent>
        <div>
          <Box>
            <Flex direction="row" align="center" gap={8}>
              <Icon icon={Broadcast} size={24} />
              <Heading type="h3" weight="bold" align="start">
                Board sources
              </Heading>
            </Flex>
            {portalSettings.boardSources.length ? (
              <Box
                rounded="small"
                border={true}
                borderColor="uiBorderColor"
                style={{
                  margin: '24px 0 8px 0',
                }}
              >
                <Box
                  style={{
                    overflowY: 'auto',
                    maxHeight: 'calc(100vh - 300px)',
                  }}
                >
                  <BoardSourceList
                    portalSettings={portalSettings}
                    supportSelectButton
                    onSelectClick={(boardSource) => {
                      onClose(boardSource);
                    }}
                  />
                </Box>
              </Box>
            ) : (
              <Box
                rounded="small"
                border={true}
                borderColor="uiBorderColor"
                style={{
                  margin: '24px 0',
                  padding: '32px 16px',
                  backgroundColor: 'rgba(103, 104, 121, 0.025)',
                }}
              >
                <Flex direction="column" gap={4}>
                  <Icon icon={Inbox} size={24} />
                  <Text type="text2" align="center" color="primary" element="p">
                    No board sources
                  </Text>
                </Flex>
              </Box>
            )}
          </Box>
          {portalSettings.boardSources.length ? (
            <Text type="text2" align="start" color="secondary" element="p" style={{ marginTop: '16px', marginBottom: '8px' }}>
              Board sources let you control the board each client sees in a board section.{' '}
              <ExternalLink
                href="https://getgorilla.app/products/client-portal/docs/user-guides/board-setup"
                style={{ display: 'inline-block' }}
              >
                Learn more
              </ExternalLink>
            </Text>
          ) : null}
        </div>
      </AppModalContent>
    </AppModal>
  );
}
